var exports = {
  "D": "xfb577c5e--b6f6af--title",
  "t": "xfb577c5e--b6f6af--title--link-block",
};

module.exports = exports;
